<template>

    <div class="contact">
      <span>在线咨询</span>
      <span><img src="../../public/images/1-2.png"></span>
      <span>
        <div>
          <span></span>
          QQ交谈
        </div>
      </span>
    </div>

</template>

<script>
export default{
  name:"sideContact",
}
</script>

<style lang="less" scoped>
.contact{
    position: fixed;
    right: 14px;
    top: 50%;
    transform: translate(0,-50%);
    border: 1px solid #dadee7;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "PingFang SC", "Droid Sans Fallback", "microsoft yahei";
    font-size: 14px;
    background-color: white;
    cursor: pointer;
    z-index:999;
    >span{
      font-weight: 500;
      &:first-child{
        padding: 8px 0;
        color: black;
      }
      &:nth-child(2){
        padding: 2px 12px 8px 12px;
        img{
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
      }
      &:nth-child(3){
        background-color: #12b7f5;
        color: white;
        display: inline-block;
        width: 100%;
        padding: 6px 0;
        div{
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: center;
          span{
            display: inline-block;
            width: 22px;
            height: 22px;
            background-image: url("../../public/images/1_1_2.png");
            background-repeat: no-repeat;
            background-position: 2px 2px;
            margin-right: 2px;
          }
        }
      }
    }
}
</style>